<template>
  <div v-if="visibleBanners.length" class="wrap-carousel">
    <b-carousel
      indicators
    >
      <b-carousel-slide
        v-for="(banner, i) in visibleBanners"
        :key="i"

      >
        <template v-slot:img>
          <a :href="banner.link" target="_blank" rel="noopener noreferrer">
            <img
              :src="`${bannerBaseURL}/storage/app/img/banner/${getBannerPicture(banner)}`"
              :alt="banner.seo_alt || banner.banner_name || 'Adman Awards banner'"
              :loading="i === 0 ? 'eager' : 'lazy'"
              :fetchpriority="i === 0 ? 'high' : 'low'"
              :width="isDesktop ? 1920 : 1127"
              :height="isDesktop ? 850 : 958"
              decoding="async"
              style="width: 100vw;"
              :class="isDesktop ? 'wrap-carousel--desktop' : 'wrap-carousel--small'"
            >
          </a>
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'
import { getApiBaseURL } from '@/environments'

export default {
  data () {
    return {
      bannerBaseURL: getApiBaseURL(),
      isDesktop: window.matchMedia('(min-width: 1024px)').matches
    }
  },

  computed: {
    ...constantsComputed,
    ...mapState({
      banners: state => state.banner.data
    }),

    visibleBanners () {
      if (!Array.isArray(this.banners)) return []

      return this.banners.filter(banner => this.getBannerPicture(banner))
    }
  },

  methods: {
    getBannerPicture (banner) {
      if (!banner) return ''

      if (this.isDesktop) {
        return banner.banner_picture || banner.banner_picture_sm
      }

      return banner.banner_picture_sm || banner.banner_picture
    },

    handleBreakpointChange (event) {
      this.isDesktop = event.matches
    },

    getBannerApi () {
      let routeName = this.$route.name
      if (routeName === 'winnerArchive') {
        routeName = 'winners'
      }
      if (routeName === 'programArchive') {
        routeName = 'archive'
      }
      if (routeName === 'privacy') {
        routeName = 'archive'
      }
      if (!this.banners) {
        this.$store.dispatch('banner/get', routeName)
      }
    }
  },

  created () {
    this.getBannerApi()
  },

  mounted () {
    this.desktopMediaQuery = window.matchMedia('(min-width: 1024px)')

    if (this.desktopMediaQuery.addEventListener) {
      this.desktopMediaQuery.addEventListener('change', this.handleBreakpointChange)
    } else {
      this.desktopMediaQuery.addListener(this.handleBreakpointChange)
    }
  },

  beforeDestroy () {
    if (!this.desktopMediaQuery) return

    if (this.desktopMediaQuery.addEventListener) {
      this.desktopMediaQuery.removeEventListener('change', this.handleBreakpointChange)
    } else {
      this.desktopMediaQuery.removeListener(this.handleBreakpointChange)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.wrap-carousel {
  aspect-ratio: 1127 / 958;
  width: 100%;
  background-color: $light;

  @media only screen and (min-width: $break-l) {
    aspect-ratio: 1920 / 850;
  }

  img {
    display: block;
    height: auto;
  }

  &--small {
    @media only screen and (min-width: $break-l) {
      display: none;
    }
  }

  &--desktop {
    display: none;

    @media only screen and (min-width: $break-l) {
      display: block;
    }
  }
}
</style>
